const landingJovenesProfesionales = {
  bannerTelefonica: 'Una herramienta interactiva que te muestra la evolución de la oferta laboral.',
}

export default landingJovenesProfesionales
